import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Index from '@/views/index'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/indexGsjp',
    name: 'indexGsjp',
    component: () => import('@/views/indexGsjp')
  },
  {
    path: '/indexMqjp',
    name: 'indexMqjp',
    component: () => import('@/views/indexMqjp')
  },
  {
    path: '/subject',
    name: 'subject',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/subject')
  },  
  {
    path: '/classify',
    name: 'classify',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/classify')
  },
  {
    path: '/classifyIndex',
    name: 'classifyIndex',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/classifyIndex')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/search')
  },
  {
    path: '/goodsDetail',
    name: 'goodsDetail',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/goodsDetail')
  },
  {
    path: '/car',
    name: 'car',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/car')
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/order')
  },
  {
    path: '/payali',
    name: 'payali',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/payali')
  },
  {
    path: '/paywx',
    name: 'paywx',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/paywx')
  },
  {
    path: '/logreg',
    name: 'logreg',
    component: () => import('@/views/logreg')
  },
  {
    path: '/user',
    name: 'user',
    meta: {
      requireAuth: true
    },
    component: () => import('@/views/user/user'),
    children: [{
        name: 'home',
        path: '/home',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/user/home')
      },
      {
        name: 'addrList',
        path: '/addrList',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/user/addrList')
      },
      {
        name: 'orderList',
        path: '/orderList',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/user/orderList')
      },
      {
        name: 'orderDetail',
        path: '/orderDetail',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/user/orderDetail')
      },
      {
        name: 'evalGoods',
        path: '/evalGoods',
        meta: {
          requireAuth: true
        },
        component: () => import('@/views/user/evalGoods')
      }
    ]
  },
  {
    path: '/helpCenter',
    name: 'helpCenter',
    component: () => import('@/views/other/helpCenter')
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/notFound')
  }
  // {
  //   path: '*', // 此处需特别注意置于最底部
  //   redirect: '/404',
  //   component: () => import('@/views/notFound')
  // }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(from)
  localStorage.setItem('idxTo', to.name)
  localStorage.setItem('idxFrom', from.name)
  // 判断该路由是否需要登录权限
  if (to.meta.requireAuth) {
    // 通过vuex state获取当前的token是否存
    if (localStorage.getItem("userToken")) {
      console.log('有token时候', to, from, next)
      next();
    } else {
      console.log('没有token时候', to)
      next({
        path: '/logreg'
      })
    }
  } else {
    next()
  }
})

export default router

// 最简单直接的使用组件
// import Home from '../views/Home'
// import Home from '@/views/Home'
// component: Home

// 按需加载
// component: () => import('@/views/About')
// component: resolve => require(['@/views/About'], resolve)

// 重定向
// redirect: '/about'
// redirect: to => {
//   console.log(to)
//   // 方法接收 目标路由 作为参数
//   // return 重定向的 字符串路径/路径对象
//   if(to.name == 'home'){
//     return '/about'
//   }
// }

// 判断该路由是否需要登录权限
// meta: {
//   requireAuth: true
// },

// 全不匹配的情况下，返回404，路由按顺序从上到下，依次匹配。
// 最后一个*能匹配全部
// 需要放到最后
// {
//   path: '*',
//   name: 'notFound',
//   meta: {
//     title: '404页面',
//   },
//   component: resolve => require(['@/views/notFound'], resolve)
// }